import { render, staticRenderFns } from "./setUtmFinal.vue?vue&type=template&id=6d85b73b"
import script from "./setUtmFinal.vue?vue&type=script&lang=js"
export * from "./setUtmFinal.vue?vue&type=script&lang=js"
import style0 from "./setUtmFinal.vue?vue&type=style&index=0&id=6d85b73b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports